import * as R from 'ramda';
import provinces from 'provinces';

// eslint-disable-next-line
export const getProvinces = country => R.filter(R.propEq('country', country), provinces);
